// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuoteListContainerComponent } from "./quote-list-container.component";
import { CardModule } from "libraries/ui_card/card.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { BookingModule } from "../../../../shared/booking/booking.module";
import { AirTripResourceModule } from "libraries/service/resources/airTrip/airTripResource.module";
import { QuoteResultModule } from "app_locobook/pages/quote-page/components/quote-result/quote-result.module";
import { PipesModule } from "libraries/pipes/pipes.module";
import { QuoteSorterModule } from "./quote-sorter/quote-sorter.module";
import { PermissionModule } from "libraries/permission/permission.module";

@NgModule({
    imports: [
        AirTripResourceModule,
        BookingModule,
        BtnModule,
        CardModule,
        CommonModule,
        QuoteResultModule,
        PipesModule,
        QuoteSorterModule,
        PermissionModule,
    ],
    declarations: [
        QuoteListContainerComponent,
    ],
    exports: [
        QuoteListContainerComponent,
    ]
})
export class QuoteListContainerModule {

}
